import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import MyPacksPage from "./pages/MyPacksPage";
import CreatePackPage from "./pages/CreatePackPage";
import EditPackPage from "./pages/EditPackPage";
import { NIP19Page } from "./pages/NIP19Page";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/my-packs" element={<MyPacksPage />} />
        <Route path="/create" element={<CreatePackPage />} />
        <Route path="/edit/:naddr" element={<EditPackPage />} />
        {/* NIP-19 route for naddr1 (emoji pack detail) */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;
